 import FieldController from '../field.controller';
import $ from 'jquery';

class SignatureFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout, $element) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);
    this.$timeout = $timeout;
    this.$element = $element;
    this.penColor = "#000";
    this.lineColor = "transparent";
    this.readonly = '=';
    return this._$signatureElement = undefined;
  }

  set $signatureElement(el) {
    this._$signatureElement = el;
  }

  get $signatureElement() {
    return this._$signatureElement;
  }

  get base30Data() {
    let data = this.value;
    if (data) {
      data = data.join(',');
    }
    return data;
  }

  $postLink() {
    // Initialize element
    let el = this.$element[0].querySelector('.signature-field');
    this.$signatureElement = $(el);

    return this.$timeout(() => this._initSignature(), 100);
  }

  _initSignature() {
    // Create jSignature settings Object
    let settings = {};
    if (this.lineColor) settings['decor-color'] = this.lineColor;
    if (this.penColor) settings.color = this.penColor;

    this.$signatureElement.jSignature(settings);

    let data = this.base30Data;
    if (data) {
      this.$signatureElement.jSignature('setData', `data:${data}`);
    }
  }

  clearData() {
    this.$signatureElement.jSignature('reset');
    this.value = '';
  }

  getData() {
    let types = ['base30', 'svgbase64', 'svg', 'native', 'default'];

    let allData = {};
    types.forEach(type => {
      allData[type] = this.$signatureElement.jSignature('getData', type);
    });

    this.value = allData['base30'];
  };
}

export default SignatureFieldController;
